import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

const microsoftLoginMutation = () => useMutation({
  mutationKey: ['microsoftLogin'],
  mutationFn: (token: string) => agent.getClient().post('/auth/microsoft/login', null, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  }),
});

export default microsoftLoginMutation;
